import { Typography, ListItemText } from '@mui/material';
import List from '../styled/List';
import ListItemIcon from '../styled/ListItemIcon';
import ListItem from '../styled/ListItem';

const AdministratorResponsibilityScopeChatbot = () => (
  <>
    <Typography variant="h5" fontWeight="700" textTransform="none">
      5B. Zakres odpowiedzialności administratora – usługa Chat/ChatBot
    </Typography>
    <List>
      <ListItem>
        <ListItemIcon>5.1.</ListItemIcon>
        <ListItemText>
          Administrator dokłada wszelkich starań w celu zapewnienia
          każdorazowej, ciągłej i pełnej dostępności usługi Chata/ChatBota,
          jednak nie gwarantuje jej i nie odpowiada za jej dostępność.
        </ListItemText>
      </ListItem>
      <ListItem>
        <ListItemIcon>5.2.</ListItemIcon>
        <ListItemText>
          W szczególności Administrator nie ponosi odpowiedzialności za przerwy
          i zakłócenia w dostępności i korzystaniu z usługi Chata/Chatbota,
          jeśli są one spowodowane:
          <List>
            <ListItem>
              <ListItemIcon>a)</ListItemIcon>
              <ListItemText>
                koniecznością naprawy, wymiany rozbudowy, modyfikacji lub
                konserwacji sprzętu komputerowego albo oprogramowania,
              </ListItemText>
            </ListItem>
            <ListItem>
              <ListItemIcon>b) </ListItemIcon>
              <ListItemText>
                przyczynami niezależnymi od Administratora Usługi (siła wyższa,
                działania/zaniechania osób trzecich).
              </ListItemText>
            </ListItem>
            <ListItem>
              <ListItemIcon>c) </ListItemIcon>
              <ListItemText>
                Administrator nie ponosi odpowiedzialności za sposób korzystania
                z usługi Chata/ChatBota przez Użytkowników, a także za treści
                przekazywane przez Użytkowników i ich prawdziwość.
              </ListItemText>
            </ListItem>
          </List>
        </ListItemText>
      </ListItem>
      <ListItem>
        <ListItemIcon>5.3.</ListItemIcon>
        <ListItemText>
          Administrator nie ponosi odpowiedzialności za niewykonanie lub
          nienależyte wykonanie usługi Chata/Chatbota, jeżeli jest to
          spowodowane przez osoby trzecie, za których działania nie odpowiada (w
          szczególności operatorów telekomunikacyjnych, dostawców łączy
          telekomunikacyjnych, energii elektrycznej).
        </ListItemText>
      </ListItem>
      <ListItem>
        <ListItemIcon>5.4.</ListItemIcon>
        <ListItemText>
          Administrator nie ponosi odpowiedzialności za szkody spowodowane
          działaniami lub zaniechaniami Użytkownika, w szczególności za
          nieprawidłowe korzystanie przez niego z usługi Chata/Chatbota, za
          korzystanie przez niego z usługi Chata/Chatbota w sposób niezgodny z
          przepisami obowiązującymi na terytorium Rzeczypospolitej Polskiej oraz
          za szkody wynikające z podania niepełnych lub nieprawdziwych danych.
        </ListItemText>
      </ListItem>
    </List>
  </>
);

export default AdministratorResponsibilityScopeChatbot;
